export const getNewNameCount = (
  nameList: string[],
  baseName: string,
  matcher?: RegExp
): number => {
  const copiedTemplates = nameList.filter(name => name.startsWith(baseName));

  if (copiedTemplates.length === 0) {
    return 0;
  }

  // Extract the highest copy number
  const copyNumbers = copiedTemplates
    .map(name => {
      const match = name.match(matcher || /\(Copy (\d+)\)$/);
      return match ? parseInt(match[1], 10) : 0;
    })
    .filter(num => !isNaN(num));

  const highestNumber = copyNumbers.length > 0 ? Math.max(...copyNumbers) : 0;

  return highestNumber + 1;
};
